import { AxiosError, AxiosInstance } from 'axios';
import { toErrorType } from '../../domain/entities/Auth';
import API_ROOT from '../../utils/api';
import { removeCookie, setCookie } from '../../utils/cookie';
import securedAxios from '../../utils/secured-axios';

export interface LoginQuery {
  email: string;
  password: string;
}

export interface LoginWithFbQuery {
  email: string;
  id: string;
  accessToken: string;
  lastName: string;
  firstName: string;
  expireAt: number;
}

export interface CreateUserQuery {
  lastName: string;
  firstName: string;
  email: string;
  password: string;
}

export interface CreateUserWithResvQuery {
  reservationId: number;
  password: string;
}

/**
 * NOTE: use coubic v2 api
 */

export class AuthRepository {
  private api: AxiosInstance;

  constructor(api: AxiosInstance) {
    this.api = api;
  }

  public async Login(email: string, password: string) {
    return this.api
      .post(`${API_ROOT}/sessions`, {
        email,
        password,
        requested_by: 'web',
      })
      .then(response => {
        const { token } = response.data;
        setCookie('token', token);
        return { errors: null };
      })
      .catch((err: AxiosError) => {
        removeCookie('token');
        return { errors: toErrorType(err.response!.data.error.code) };
      });
  }

  public async LoginWithFb(query: LoginWithFbQuery) {
    return this.api
      .post(`${API_ROOT}/sessions/omniauth`, {
        email: query.email,
        id: query.id,
        token: query.accessToken,
        last_name: query.lastName,
        first_name: query.firstName,
        expires_at: query.expireAt,
        provider: 'facebook',
        requested_by: 'web',
      })
      .then(response => {
        const { token } = response.data;
        setCookie('token', token);
        return { errors: null };
      })
      .catch((err: AxiosError) => {
        removeCookie('token');
        return { errors: toErrorType(err.response!.data.error.code) };
      });
  }

  public async CreateUserWithResv(query: CreateUserWithResvQuery) {
    return this.api
      .post(`${API_ROOT}/users/new`, {
        reservation_id: query.reservationId,
        password: query.password,
      })
      .then(response => {
        const { token } = response.data;
        setCookie('token', token);
        return { errors: null };
      })
      .catch((err: AxiosError) => {
        removeCookie('token');
        return { errors: toErrorType(err.response!.data.error.code) };
      });
  }

  public async CreateUser(query: CreateUserQuery) {
    return this.api
      .post(`${API_ROOT}/users/new`, {
        last_name: query.lastName,
        first_name: query.firstName,
        email: query.email,
        password: query.password,
      })
      .then(response => {
        const { token } = response.data;
        setCookie('token', token);
        return { errors: null };
      })
      .catch((err: AxiosError) => {
        removeCookie('token');
        return { errors: toErrorType(err.response!.data.error.code) };
      });
  }

  public async Logout() {
    await this.api
      .post(`${API_ROOT}/sessions/logout`)
      .then(() => {
        removeCookie('token');
      })
      .catch((err: AxiosError) => {
        throw err;
      });
  }
}

export default new AuthRepository(securedAxios);
